import { ItemArt } from "@/components/quote/ItemArt";

const artKey = (group, v) => `style_${group === "cabinet" ? "cab" : "door"}_${v}`;

export const StylePicker = ({ group, options, value, count, onPick, onApplyAll, testId }) => (
  <div className="mt-2.5 border-t border-[#262626] pt-2.5" data-testid={testId}>
    <div className="mb-2 flex items-center justify-between gap-2">
      <p className="text-[11px] text-[#A0A0A0]">{group === "cabinet" ? "Cabinet" : "Door"} style <span className="text-[#666]">· for the record, doesn't change the price</span></p>
      {value && count > 1 && (
        <button onClick={onApplyAll} data-testid={`${testId}-apply-all`} className="rounded-full border border-[#555] px-3 py-1 text-[10px] font-extrabold tracking-[0.5px] text-white transition-colors hover:border-[#4CCC06]">APPLY TO ALL {count}</button>
      )}
    </div>
    <div className="grid grid-cols-3 gap-1.5 sm:grid-cols-6">
      {options.map((o) => {
        const on = value === o.value;
        return (
          <button key={o.value} onClick={() => onPick(on ? null : o.value)} data-testid={`${testId}-${o.value}`} aria-pressed={on}
            className={`group flex flex-col items-center rounded-[10px] border p-1.5 transition-[border-color,background-color,transform] hover:-translate-y-0.5 ${on ? "border-[#4CCC06] bg-[#4CCC0614]" : "border-[#333] bg-[#0E0E0E] hover:border-[#555]"}`}>
            <ItemArt type={artKey(group, o.value)} className={`h-14 w-14 transition-colors ${on ? "text-[#4CCC06]" : "text-[#D0D0D0] group-hover:text-white"}`} />
            <span className={`mt-1 text-[10px] font-bold leading-3 ${on ? "text-[#4CCC06]" : "text-white"}`}>{o.label}</span>
          </button>
        );
      })}
    </div>
  </div>
);
